import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { GuardSamplesPage } from "@/features/quality/components/guard/guard-samples-page";

const search = z.object({
  tab: z.enum(["to_store", "stored", "discarded"]).default("to_store"),
  from: z.string().optional(),
  to: z.string().optional(),
  cropId: z.number().int().positive().optional(),
  varietyId: z.number().int().positive().optional(),
  q: z.string().optional(),
  // Lot wise or SRF wise; the page opens SRF wise.
  view: z.enum(["lot", "srf"]).optional(),
  // The finished tab's page; the live tabs scroll.
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/guard-samples/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.guard_samples"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <GuardSamplesPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
